export enum ProductsEnumerator {
    LMS_STUDENT = 3,
    LMS_EDUCATOR = 4,
  }